import { FC, useEffect } from 'react';
import toast from 'react-hot-toast';
import { useSearchParams } from 'react-router-dom';

import { useDbtCloudProject } from '@/context/DbtCloudProjectProvider';
import { useProject } from '@/hooks/admin/project';

export const XPIndicatorFn: FC = () => {
  const { accountId, projectId } = useDbtCloudProject();
  const [searchParams, setSearchParams] = useSearchParams();
  const originProject = searchParams.get('originProject');
  const originProjectId = parseInt(originProject ?? '');
  const newProjectName = useProject({
    accountId,
    projectId,
  }).data?.name;
  useEffect(() => {
    if (originProjectId && newProjectName) {
      toast(`Now viewing project: "${newProjectName}" in a new tab.`, {
        position: 'top-center',
        duration: 3000,
        style: {
          background: '#333',
          color: '#fff',
          maxWidth: '100%',
        },
      });
      searchParams.delete('originProject');
      setSearchParams(searchParams);
    }
  }, [newProjectName, originProjectId, searchParams, setSearchParams]);
  return null;
};
